import React from 'react';
import { Box, Typography } from '@mui/material';
import NoEquivalent from '../NoEquivalent';

const ArticleCriteria = ({ criterias = [] }) => {
  if (criterias.length === 0) {
    return (
      <Box
        sx={{
          height: '100px',
          boxShadow: '0px 12px 26px #0000000D',
          borderRadius: 1.4,
          m: 1.5,
        }}
      >
        <NoEquivalent message="AUCUNE CARACTÉRISTIQUE DISPONIBLE POUR CE PRODUIT." />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        maxHeight: '200px',
        overflow: 'auto',
        boxShadow: '0px 12px 26px #0000000D',
        borderRadius: 1.4,
        m: 1.5,
      }}
      display="flex"
      flexWrap="wrap"
    >
      {criterias.map((crit, index) => (
        <Box
          key={crit.criteriaAbbrDescription}
          sx={{
            p: 1,
            mr: index % 2,
            ml: 1 - (index % 2),
            borderRight: '1px solid #0000000D',
            borderBottom: '1px solid #0000000D',
            borderLeft: '1px solid #0000000D',
          }}
          width="calc(50% - 32px)"
        >
          <Typography sx={{
            font: 'normal normal 600 10px Montserrat',
            color: '#707070',
          }}
          >
            {crit.criteriaAbbrDescription || '-'}
          </Typography>
          <Typography sx={{
            font: 'normal normal 600 14px Montserrat',
            color: '#38485C',
          }}
          >
            {crit.formattedValue}
            {crit.criteriaUnitDescription ? ` ${crit.criteriaUnitDescription}` : null}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ArticleCriteria;
